import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Common, NewCommon } from "./wrappers";
import LFeed from "../../../../services/live-feed"

const safe = (cb, or = null) => {
	try {
		return cb();
	} catch (e) {
		return or;
	}
};

const EVENT_CLASSES = {
	Ace: "set",
	Point: "point_text",
	ServiceFault: "fault_text",
	DoubleFault: "fault_text",
	Finished: "set",
	FirstSet: "set",
	SecondSet: "set",
	ThirdSet: "set",
	FourthSet: "set",
	FifthSet: "set",
	InjuryBreak: "set",
	RainDelay: "set",
	Timeout: "set",
};

export default class TennisTracker extends Component {
	render({ event, lastEventName = event.misc.tracker.name || "" }) {
		const tournament = LFeed.getTournament(event.parent)
		if (!event.misc.info)
			return null;
		return <Common event={event}>
			<div
				class={"field field-0"}
				data-fieldtype={
					tournament.label.match(/clay|Clay|clay court/g)
						? "clayField"
						: tournament.label.match(/hard|Hard|hard court/g)
						? "hardField"
						: tournament.label.match(/grass|Grass|Soft|soft/g)
						? "softField"
						: ""
				}
			>
				<div
					class={`${lastEventName === "Game" ? "BallInPlay" : lastEventName} side_${
						event.misc.tracker.team == "home" ? 1 : 2
					} ${event.misc.info.pass_team == "team1" ? "left" : "right"}`}
				>
					<div class="infoPhase">
						<span className="infoPhase_label">{event.status.phase}</span>
						<span class="infoPhase_score">
							{safe(() => event.misc.stats.set.team1_value)}:{safe(() => event.misc.stats.set.team2_value)}
							<span>
								({safe(() => event.misc.stats.score.team1_value)}-{safe(() => event.misc.stats.score.team2_value)})
							</span>
						</span>
					</div>
					<div>
						{lastEventName === "BallInPlay" || lastEventName === "Ace" || lastEventName === "Game" ? (
							<div class="ball_container">
								<div class="ball" />
								<div class="ball_shadow" />
							</div>
						) : null}
						{lastEventName === "Point"
							? [
									<div key="Point-score_1" class="score_1">
										{event.misc.stats && event.misc.stats.score && (
											<span>{event.misc.stats.score.team1_value}</span>
										)}
									</div>,
									<div key="Point-score_2" class="score_2">
										{event.misc.stats && event.misc.stats.score && (
											<span>{event.misc.stats.score.team2_value}</span>
										)}
										{console.log({ event })}
									</div>,
							  ]
							: null}
						{lastEventName !== "BallInPlay" && lastEventName !== "Game" ? (
							<div class={EVENT_CLASSES[lastEventName]} title={lastEventName}>
								{lastEventName.replace(/[A-Z]/g, (letter, idx) => (idx == 0 ? letter : ` ${letter}`))}
							</div>
						) : null}
					</div>
				</div>
			</div>
		</Common>;
	}
}
